import PrimaryAction from './PrimaryAction';

export default PrimaryAction;
